import React, { useState, useEffect } from 'react';
import { Page, SearchBar } from 'components';
import { Results } from './components';
import Reload from '../../components/Reload/Reload';
import Header from 'components/Header/Header';
import { Row, Col, Alert } from 'react-bootstrap';
import { loadState, saveState } from 'utils/persistState';
import { getCertificados } from './assistenciasCertificadosApi';
import {
  hasCertificadosReadPermission,
  mapCertificadoFilesToCertificados,
} from './assistenciasCertificadosUtils';
import { useAppTheme } from '../../contexts/ThemeContext';

const STORAGE_KEY = 'filters:assistencias-certificados';

const AssistenciasCertificados = () => {
  const user = JSON.parse(localStorage.getItem('userData') || 'null');

  if (!hasCertificadosReadPermission(user)) {
    window.location.replace('/home');
  }

  const [certificados, setCertificados] = useState([]);
  const [tempCertificados, setTempCertificados] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  const currentTheme = useAppTheme();

  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  const loadCertificados = async () => {
    try {
      setLoading(true);
      setLoadError('');
      const files = await getCertificados();
      const mapped = mapCertificadoFilesToCertificados(files);
      setCertificados(mapped);
      setTempCertificados(mapped);
    } catch (error) {
      console.error('Erro ao carregar certificados:', error);
      setLoadError('Não foi possível carregar os certificados. Tente novamente mais tarde.');
      setCertificados([]);
      setTempCertificados([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCertificados();
  }, []);

  const handleSearch = () => {
    if (!searchData.trim()) {
      setTempCertificados(certificados);
      return;
    }

    const term = searchData.toUpperCase();
    const filtered = certificados.filter((item) =>
      ['serialnumber', 'cupid', 'fileName'].some(
        (key) => item?.[key] && String(item[key]).toUpperCase().includes(term)
      )
    );
    setTempCertificados(filtered);
  };

  useEffect(() => {
    handleSearch();
  }, [certificados, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  return (
    <Page className="p-3" title="Certificados">
      <Header page="Certificados" />

      {loading && <Reload />}

      {loadError && (
        <Alert variant="danger" className="mt-3">
          {loadError}
        </Alert>
      )}

      <Row className="mt-3">
        <Col xs={12} md={8} lg={6}>
          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
          />
        </Col>
      </Row>

      {!loading && tempCertificados && (
        <Results
          data={tempCertificados}
          currentTheme={currentTheme}
        />
      )}
    </Page>
  );
};

export default AssistenciasCertificados;
